export const ProductLabelTextHelper = {
    getLabelText: {
        productId: 'Product ID',
        sku: 'SKU',
        title: 'Title',
        description: 'Description',
        categoryCode: 'Category Code',
        dateCreateAt: 'Create date',
        dateModifyAt: 'Modify date',
        dateCreateAtFrom: 'Create Date From',
        dateCreateAtTo: 'Create Date To',
        latestProductCost: 'Latest Cost HKD',
        latestEstimatedShippingFee: 'Latest Estimated Shipping Fee HKD',
        action: 'Action'
    }
};
